define('TescoMobile_Checkout/js/view/about/sim-request',['ko', 'uiComponent', 'Magento_Checkout/js/model/quote', 'mage/translate'], function (ko, Component, quote, $t) {
  'use strict';

  var _quote$getData;
  const checkoutConfig = window.checkoutConfig;
  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/about/sim-request'
    },
    isVisible: ((_quote$getData = quote.getData('extension_attributes')) === null || _quote$getData === void 0 ? void 0 : _quote$getData.tm_quote_type) === 'UPGRADE',
    hasSimInfo: ko.observable(true),
    needsSimUpdate: ko.observable(false),
    getDeviceSimSupport: function () {
      var itemId = quote.getItems()[0].item_id,
        simTypes = checkoutConfig.tescomobile.specification.sim_type,
        value = null;
      if (simTypes[itemId]) {
        var simText = simTypes[itemId].toLowerCase();
        if (simText.indexOf('standard') > -1) {
          value = 'standard';
        }
        if (simText.indexOf('nano') > -1) {
          value = value ? value + ' and nano' : 'nano';
        }
        if (simText.indexOf('micro') > -1) {
          value = value ? value + ' and micro' : 'micro';
        }
      }
      if (!value) {
        this.hasSimInfo(false);
      }
      return $t('Your new phone uses a %1 SIM.').replace('%1', value);
    }
  });
});

